var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/RuleEditor/RuleEditor.tsx";
import { Box } from '@gmini/ui-kit/lib/Box';
import { FormulaeEditorLayout } from '@gmini/ui-kit';
import { SimpleConditionsContainer } from "../SimpleConditionsContainer";
import { DifficultConditions } from "../DifficultConditions";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RuleEditor = function RuleEditor(_ref) {
  var currentGroup = _ref.currentGroup,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("div", {
    style: {
      height: '100%'
    },
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(FormulaeEditorLayout, {
      disabled: disabled,
      children: [/*#__PURE__*/_jsx(Box, {
        pt: "16px",
        pb: "20px",
        style: {
          pointerEvents: 'none'
        },
        children: /*#__PURE__*/_jsx(SimpleConditionsContainer, {
          currentGroup: currentGroup,
          readonly: true
        })
      }), /*#__PURE__*/_jsx(Box, {
        pb: 5,
        children: /*#__PURE__*/_jsx(DifficultConditions, {
          currentGroup: currentGroup,
          readonly: true
        })
      })]
    })
  });
};